import { render } from "./NavBar.vue?vue&type=template&id=5af8f0bc&scoped=true"
import script from "./NavBar.vue?vue&type=script&lang=js"
export * from "./NavBar.vue?vue&type=script&lang=js"

import "./NavBar.vue?vue&type=style&index=0&id=5af8f0bc&scoped=true&lang=scss"

import exportComponent from "D:\\Note\\WEB DESIGN\\NEED FILE\\PRACTICE\\VUE PROJECTS\\royal-shop\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5af8f0bc"]])

export default __exports__